import type { RouteRecordRaw } from 'vue-router';
import { Addon, Feature, Permission } from '~/middlewares';
import { adminRoutes } from './admin';
import { authRoutes } from './auth';
import { clientRoutes } from './client';
import { fallbackRoutes } from './fallback';
import { serverRoutes } from './server';

export const routes: RouteRecordRaw[] = [...authRoutes, ...clientRoutes, ...serverRoutes, ...adminRoutes, ...fallbackRoutes];

// Global middlewares always run before any per-route meta.middlewares, in this order.
export const globalMiddlewares: Middleware[] = [Feature, Addon, Permission];
